module.exports = __webpack_public_path__ + "static/media/twitter.a55aa117.png";